/*
 * @Descripttion:
 * @version: 0.0.1
 * @Author: gavin chan
 * @Date: 2020-05-28 11:38:13
 * @LastEditors: gavin chan
 * @LastEditTime: 2020-09-08 10:36:30
 * @Notes:
 */

import { RootDispatch } from "store";
import Axios from "utils/request";
import { WORKBENCH_API_URL } from "utils/config";

const getCouponsAsync = async (data: any) => {
  return await Axios({ url: WORKBENCH_API_URL + "erp/coupon/index", data });
};

const toggleCouponStatusAsync = async (data: any) => {
  return await Axios({ url: WORKBENCH_API_URL + "erp/coupon/open", data });
};

const updateStockAsync = async (data: any) => {
  return await Axios({ url: WORKBENCH_API_URL + "erp/coupon/stock", data });
};

// const sendCouponAsync = async (data: any) => {
//   return await Axios({ url: WORKBENCH_API_URL + "erp/coupon/issue", data });
// };

const addCouponAsync = async (data: any) => {
  return await Axios({ url: WORKBENCH_API_URL + "erp/coupon/submit", data });
};

const getCouponRedcordsAsync = async (data: any) => {
  return await Axios({
    url: WORKBENCH_API_URL + "erp/coupon/itemlist",
    method: "get",
    data,
  });
};

const getProductCateAsync = async () => {
  return await Axios({
    url: WORKBENCH_API_URL + "/erp/order/getProductCate",
  });
};

const getQRCodeAsync = async (data: any) => {
  return await Axios({
    url: WORKBENCH_API_URL + "erp/coupon/getCode",
    method: "get",
    data,
  });
};

const getCouponDetailAsync = async (data: any) => {
  return await Axios({
    url: WORKBENCH_API_URL + "erp/coupon/getCoupon",
    method: "get",
    data,
  });
};

const delCouponAsync = async (data: any) => {
  return await Axios({
    url: WORKBENCH_API_URL + "/erp/coupon/delete",
    method: "get",
    data,
  });
};

export type CouponsState = {
  coupons: {
    list: Array<any>;
    total: number;
  };
  couponRecords: {
    list: Array<Object>;
    total: number;
  };
};

export const coupons = {
  state: {
    coupons: {
      list: [],
      total: 0,
    },
    couponRecords: {
      list: [],
      total: 0,
    },
  }, // initial state
  reducers: {
    // handle state changes with pure functions
    setCoupons(state: CouponsState, payload: any) {
      // state.coupons.list.concat(payload.list);
      // state.coupons.total = payload.total;
      state.coupons = payload;
      return state;
    },
    setCouponRecords(state: CouponsState, payload: any) {
      state.couponRecords = payload;
      return state;
    },
    removeCoupon(state: CouponsState, payload: any) {
      state.coupons.list.splice(payload.index, 1);
      return state;
    },
    updateStock(state: CouponsState, payload: any) {
      // state.coupons.list.splice(payload.index, 1, payload.rowData);
      state.coupons.list[payload.index].stock = payload.stock;
      return state;
    },
    toggleCouponStatus(state: CouponsState, payload: any) {
      state.coupons.list[payload.index].status = payload.status;
    },
  },
  effects: (dispatch: RootDispatch) => ({
    // handle state changes with impure functions.
    // use async/await for async actions
    async getCoupons(data) {
      const coupons: any = await getCouponsAsync(data);
      dispatch.coupons.setCoupons(coupons.data);
    },
    async getQRCode(data) {
      return await getQRCodeAsync(data);
    },
    async updateStockAsync(data) {
      const result: any = await updateStockAsync(data);
      if (result.code === "0000") {
        dispatch.coupons.updateStock(data);
      }
      return result;
    },
    async addCoupon(data) {
      return await addCouponAsync(data);
    },
    async getProductCate() {
      return await getProductCateAsync();
    },
    async getCouponRedcordsAsync(data) {
      const result: any = await getCouponRedcordsAsync(data);
      dispatch.coupons.setCouponRecords(result.data);
      return result.data;
    },
    async getCouponDetailAsync(data) {
      return await getCouponDetailAsync(data);
    },
    async toggleCouponStatusAsync(data) {
      const result: any = await toggleCouponStatusAsync(data);
      return result;
    },
    async delCouponAsync(data) {
      return await delCouponAsync(data);
    },
  }),
};
